import {
    Box,
    Button,
    Card,
    CardActions,
    CardContent,
    CardMedia,
    FormControl,
    FormHelperText,
    Grid,
    TextField,
    Typography
} from '@mui/material';
import { useEffect, useState } from 'react';
import { Controller, useForm } from 'react-hook-form';
import toast from 'react-hot-toast';
import { useNavigate, useParams } from 'react-router-dom';
import { apiService } from '../../api/axiosClient';
import Page from '../../components/Page';
import CustomChip from '../../components/mui/chip';
import { useGetQuestionsQuery } from '../../store/questionApi';

const Question = () => {
    const params = useParams();
    const navigate = useNavigate();
    const [question, setQuestion] = useState();
    const [product, setProduct] = useState({});
    const { refetch } = useGetQuestionsQuery();
    const {
        control,
        handleSubmit,
        formState: { errors },
        reset,
    } = useForm();

    const getProduct = async (sku) => {
        try {
            const response = await apiService.get(`/products/${sku}`);
            const payload = response.data;
            setProduct(payload.data);
        } catch (e) {
            console.error('Error fetching product:', e);
        }
    }

    useEffect(() => {
        const fetchQuestion = async () => {
            try {
                const response = await apiService.get(`/questions/${params.id}`);
                const payload = response.data;
                setQuestion(payload.data);
                const sku = payload.data.sku;
                if (sku != null) {
                    getProduct(sku);
                }
            } catch (e) {
                console.error('Error fetching question:', e);
            }
        };

        fetchQuestion();
    }, [params.id]);

    useEffect(() => {
        const defaultValues = {
            username: question?.username,
            title: question?.title,
            descript: question?.descript,
            reply: question?.reply,
            uptime: question?.uptime,
        }
        reset(defaultValues)

    }, [reset, question]);

    const goBack = () => {
        navigate(-1)
    }

    const onSubmit = async (data, e) => {
        const params = {
            "reply": data.reply
        };

        try {
            const response = await apiService.put(`/questions/${question.qid}`, params);
            toast.success('수정 되었습니다');
            refetch();
            goBack();
        } catch (error) {
            console.error('Error updating question:', error);
        }
    }

    const currencyLocale = Intl.NumberFormat('ko-KR');

    return (
        <Page title="Question">
            <Card>
                <form onSubmit={handleSubmit(onSubmit)} id="qform">
                    <CardContent sx={{ pt: 8 }}>
                        <Box sx={{ mb: 9, textAlign: 'center' }}>
                            <Typography variant='h5' sx={{ mb: 3, lineHeight: '2rem' }}>
                                문의
                            </Typography>
                        </Box>

                        <Grid container spacing={6}>
                            <Grid item xs={12} md={6}>
                                <FormControl fullWidth>
                                    <Controller
                                        name='username'
                                        control={control}
                                        rules={{ required: true }}
                                        defaultValue=""
                                        render={({ field: { value, onChange } }) => (
                                            <TextField
                                                disabled
                                                value={value}
                                                label='고객ID'
                                                id='username'
                                                onChange={onChange}
                                                placeholder='제목을 입력해주세요'
                                                error={Boolean(errors.username)}
                                                aria-describedby='validation-async-username'
                                                variant="standard"
                                            />
                                        )}
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <FormControl fullWidth>
                                    <Controller
                                        name='title'
                                        control={control}
                                        rules={{ required: true }}
                                        defaultValue=""
                                        render={({ field: { value, onChange } }) => (
                                            <TextField
                                                disabled
                                                value={value}
                                                label='제목'
                                                id='title'
                                                onChange={onChange}
                                                placeholder='제목을 입력해주세요'
                                                error={Boolean(errors.title)}
                                                aria-describedby='validation-async-title'
                                                variant="standard"
                                            />
                                        )}
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={12}>
                                <FormControl fullWidth>
                                    <Controller
                                        name='descript'
                                        control={control}
                                        rules={{ required: true }}
                                        defaultValue=""
                                        render={({ field: { value, onChange } }) => (
                                            <TextField
                                                disabled
                                                value={value}
                                                label='내용'
                                                id='descript'
                                                onChange={onChange}
                                                placeholder='제목을 입력해주세요'
                                                error={Boolean(errors.descript)}
                                                aria-describedby='validation-async-descript'
                                                variant="standard"
                                            />
                                        )}
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={12}>
                                <FormControl fullWidth>
                                    <Controller
                                        name='reply'
                                        control={control}
                                        rules={{ required: true }}
                                        defaultValue=""
                                        render={({ field: { value, onChange } }) => (
                                            <TextField
                                                value={value}
                                                label='회신'
                                                id='reply'
                                                onChange={onChange}
                                                placeholder='제목을 입력해주세요'
                                                error={Boolean(errors.reply)}
                                                aria-describedby='validation-async-reply'
                                                variant="standard"
                                            />
                                        )}
                                    />
                                    {errors.reply && (
                                        <FormHelperText sx={{ color: 'error.main' }} id='validation-async-reply'>
                                            필수
                                        </FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>

                            {
                                product.sku && 
                                <Grid item xs={12}>
                                    <Card sx={{display: 'flex'}}>
                                        <CardMedia sx={{ height: 150, width: '30%', maxWidth: '200px' }} image={product.imageUrl} />
                                        <CardContent sx={{pl: 8}}>
                                            <Typography variant='h5' color='primary' sx={{mb: 2}}>구매 제품</Typography>
                                            <div>{product.category}</div>
                                            <Typography variant='h6'>{product.brand} {product.name}</Typography>
                                            <div>{currencyLocale.format(product.price)}원</div>
                                        </CardContent>
                                    </Card>
                                </Grid>
                            }
                            
                            <Grid item xs={12}>
                                <CustomChip
                                    skin='light'
                                    color='info'
                                    label={`등록날짜: ${question?.uptime}`}
                                    sx={{ '& .MuiChip-label': { color: 'common.black' } }}
                                />
                            </Grid>
                        </Grid>
                    </CardContent>
                </form>

                <CardActions className='card-action'>
                    <Button type="submit" form="qform" variant='contained'> 수정 </Button>
                    <Button variant='outlined' color='secondary' onClick={goBack}> 취소 </Button>
                </CardActions>
            </Card>
        </Page>
    )
}

export default Question